import React from "react"
import { useTranslation } from "react-i18next"

import SettingContentWrapper from "@/modules/shared/SettingContentWrapper"
import EcommerceShopDeliveryMethods from "./components/EcommerceShopDeliveryMethods"

import { EcommerceIntegration } from "@/types/ecommerce"

import { MediumText } from "@/UI"
import PreviousButton from "@/UI/PreviousButton"

interface EcommerceShopSettingsProps {
  resetStoreFocus: () => void
  ecommerceIntegration: EcommerceIntegration
}

const EcommerceShopSettings: React.FC<EcommerceShopSettingsProps> = ({
  ecommerceIntegration,
  resetStoreFocus,
}) => {
  const { t } = useTranslation()

  return (
    <div id="ecommerce-shop-setting-page">
      <div id="back-from-shop-settings">
        <PreviousButton onBackClick={resetStoreFocus} />
      </div>
      <SettingContentWrapper>
        <div className="flex flex-col gap-y-4">
          <div className="flex gap-x-4">
            <MediumText className="font-semibold">
              {t("profile.EcommerceSettings.shopName")}
            </MediumText>
            <p className="text-[#70747D] font-normal">{ecommerceIntegration.name}</p>
          </div>
          <EcommerceShopDeliveryMethods ecommerceIntegration={ecommerceIntegration} />
        </div>
      </SettingContentWrapper>
    </div>
  )
}

export default EcommerceShopSettings
